import { PanelItemGroup } from '../panel-item-group.class';

export const canMoveCfn = (panelItemGroup: PanelItemGroup): boolean => {
	// If position is locked, the appliance cannot be moved
	if (panelItemGroup.positionLocked) {
		return false;
	}
	return true;
};
